import type { ReactNode } from 'react'

export type BadgeTone =
  | 'lime'
  | 'orange'
  | 'pos'
  | 'neg'
  | 'dim'
  | 'gray'

const TONES: Record<BadgeTone, string> = {
  lime: 'border-lime-strong text-crt-lime',
  orange: 'border-crt-orange text-crt-orange',
  pos: 'border-crt-pos text-crt-pos',
  neg: 'border-crt-neg text-crt-neg',
  dim: 'border-crt-dim text-crt-dim',
  gray: 'border-crt-dim text-crt-gray',
}

export function Badge({
  tone = 'gray',
  children,
  title,
}: {
  tone?: BadgeTone
  children: ReactNode
  title?: string
}) {
  return (
    <span
      title={title}
      className={`inline-block border px-1.5 py-0.5 text-[10px] uppercase tracking-wider ${TONES[tone]}`}
    >
      {children}
    </span>
  )
}

export function SidePill({ side }: { side: 'BUY' | 'SELL' }) {
  return <Badge tone={side === 'BUY' ? 'pos' : 'neg'}>{side}</Badge>
}
